import React from 'react';
import { X } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
interface RepaymentDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onMarkPaid: () => void;
  data: any;
}
const installments = [{
  no: 1,
  due: '15 Jan 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 7,500',
  penalty: '—',
  total: 'PKR 49,167',
  status: 'Paid',
  paidDate: '14 Jan 2026'
}, {
  no: 2,
  due: '15 Feb 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 7,200',
  penalty: '—',
  total: 'PKR 48,867',
  status: 'Paid',
  paidDate: '15 Feb 2026'
}, {
  no: 3,
  due: '15 Mar 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 6,900',
  penalty: '—',
  total: 'PKR 48,567',
  status: 'Paid',
  paidDate: '14 Mar 2026'
}, {
  no: 4,
  due: '15 Apr 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 6,600',
  penalty: '—',
  total: 'PKR 48,267',
  status: 'Paid',
  paidDate: '15 Apr 2026'
}, {
  no: 5,
  due: '15 May 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 6,300',
  penalty: 'PKR 500',
  total: 'PKR 48,467',
  status: 'Overdue',
  paidDate: '—'
}, {
  no: 6,
  due: '15 Jun 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 6,000',
  penalty: '—',
  total: 'PKR 47,667',
  status: 'Pending',
  paidDate: '—'
}, {
  no: 7,
  due: '15 Jul 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 5,700',
  penalty: '—',
  total: 'PKR 47,367',
  status: 'Pending',
  paidDate: '—'
}, {
  no: 8,
  due: '15 Aug 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 5,400',
  penalty: '—',
  total: 'PKR 47,067',
  status: 'Pending',
  paidDate: '—'
}, {
  no: 9,
  due: '15 Sep 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 5,100',
  penalty: '—',
  total: 'PKR 46,767',
  status: 'Pending',
  paidDate: '—'
}, {
  no: 10,
  due: '15 Oct 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 4,800',
  penalty: '—',
  total: 'PKR 46,467',
  status: 'Pending',
  paidDate: '—'
}, {
  no: 11,
  due: '15 Nov 2026',
  principal: 'PKR 41,667',
  interest: 'PKR 4,500',
  penalty: '—',
  total: 'PKR 46,167',
  status: 'Pending',
  paidDate: '—'
}, {
  no: 12,
  due: '15 Dec 2026',
  principal: 'PKR 41,663',
  interest: 'PKR 4,200',
  penalty: '—',
  total: 'PKR 45,863',
  status: 'Pending',
  paidDate: '—'
}];
export function RepaymentDetailModal({
  isOpen,
  onClose,
  onMarkPaid,
  data
}: RepaymentDetailModalProps) {
  if (!isOpen || !data) return null;
  const appStatus = data.appStatus || 'Active';
  const paidCount = installments.filter(i => i.status === 'Paid').length;
  const remainingCount = installments.length - paidCount;
  const effectiveStatus = appStatus;
  const showRepaymentHistory = effectiveStatus === 'Active' || effectiveStatus === 'Settled';
  const getActivityLog = () => {
    const logs = [{
      type: 'Application Created',
      description: 'Loan application submitted by customer',
      date: '10 Jan 2026',
      time: '09:15 AM'
    }];
    if (effectiveStatus === 'Active' || effectiveStatus === 'Settled') {
      logs.push({
        type: 'Loan Disbursed',
        description: 'Funds transferred via RAAST to customer account',
        date: '12 Jan 2026',
        time: '11:30 AM'
      }, {
        type: 'Repayment Paid',
        description: 'Installment #1 received — PKR 49,167',
        date: '14 Jan 2026',
        time: '02:45 PM'
      }, {
        type: 'Repayment Paid',
        description: 'Installment #2 received — PKR 48,867',
        date: '15 Feb 2026',
        time: '10:20 AM'
      }, {
        type: 'Repayment Paid',
        description: 'Installment #3 received — PKR 48,567',
        date: '14 Mar 2026',
        time: '03:10 PM'
      }, {
        type: 'Repayment Paid',
        description: 'Installment #4 received — PKR 48,267',
        date: '15 Apr 2026',
        time: '09:55 AM'
      }, {
        type: 'Penalty Applied',
        description: 'Late payment penalty of PKR 500 applied on installment #5',
        date: '16 May 2026',
        time: '12:00 PM'
      });
    }
    if (effectiveStatus === 'Settled') {
      logs.push({
        type: 'Loan Settled',
        description: 'All outstanding dues cleared. Loan marked as settled.',
        date: '15 Dec 2026',
        time: '04:30 PM'
      });
    }
    return logs.reverse();
  };
  const activityLog = getActivityLog();
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-392">
      <div className="fixed inset-0 bg-gray-900/50 transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-393" />

      <div className="relative w-full max-w-4xl max-h-[90vh] flex flex-col bg-white rounded-lg shadow-xl transition-all" data-id="element-394">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-395">
          <h3 className="text-lg font-semibold leading-6 text-gray-900" data-id="element-396">
            Loan Detail View
          </h3>
          <button type="button" className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none" onClick={onClose} data-id="element-397">
            <span className="sr-only" data-id="element-398">Close</span>
            <X className="h-6 w-6" aria-hidden="true" data-id="element-399" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-8" data-id="element-400">
          {/* SECTION 1: APPLICATION DETAILS */}
          <div data-id="element-401">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-402">
              Application Details
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4" data-id="element-403">
              <div data-id="element-404">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-405">
                  Application ID
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-406">
                  {data.appId || 'APP-55678'}
                </dd>
              </div>
              <div data-id="element-407">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-408">
                  Loan ID
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-409">
                  {data.loanId || 'LN-10234'}
                </dd>
              </div>
              <div data-id="element-410">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-411">
                  Customer Name
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-412">
                  {data.applicant || data.customerName || 'Khan Enterprises'}
                </dd>
              </div>
              <div data-id="element-413">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-414">
                  Customer CNIC / ID
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-415">42101-1234567-1</dd>
              </div>
              <div data-id="element-416">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-417">
                  Product Name
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-418">
                  Business Term Loan
                </dd>
              </div>
              <div data-id="element-419">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-420">
                  Loan Amount
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-421">
                  {data.amount || 'PKR 500,000'}
                </dd>
              </div>
              <div data-id="element-422">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-423">
                  Tenure
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-424">
                  {data.tenure || '12 months'}
                </dd>
              </div>
              <div data-id="element-425">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-426">
                  Interest Type
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-427">Reducing Balance</dd>
              </div>
              <div data-id="element-428">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-429">
                  Interest Rate
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-430">17%</dd>
              </div>
              <div data-id="element-431">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-432">
                  Application Status
                </dt>
                <dd className="mt-1" data-id="element-433">
                  <StatusBadge status={appStatus} data-id="element-434" />
                </dd>
              </div>
              <div data-id="element-435">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-436">
                  Application Date
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-437">
                  {data.submissionDate || data.date || '10 Jan 2026'}
                </dd>
              </div>
            </div>
          </div>

          {/* SECTION 2: DISBURSEMENT STATUS & ACTION */}
          <div data-id="element-438">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-439">
              Disbursement Status & Action
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4" data-id="element-440">
              <div data-id="element-441">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-442">
                  Disbursement Status
                </dt>
                <dd className="mt-1" data-id="element-443">
                  <StatusBadge status={appStatus === 'Active' || appStatus === 'Settled' ? 'Disbursed' : 'Pending'} data-id="element-444" />
                </dd>
              </div>
              <div data-id="element-445">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-446">
                  Disbursement Method
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-447">
                  {data.method || 'RAAST'}
                </dd>
              </div>
              <div data-id="element-448">
                <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-449">
                  Disbursement Date
                </dt>
                <dd className="mt-1 text-sm text-gray-900" data-id="element-450">
                  {appStatus === 'Active' || appStatus === 'Settled' ? '12 Jan 2026' : '—'}
                </dd>
              </div>
            </div>
          </div>

          {/* SECTION 3: REPAYMENT DETAILS & HISTORY */}
          <div data-id="element-451">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-452">
              Repayment Details & History
            </h4>

            {showRepaymentHistory ? <>
                {/* Summary Cards */}
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6" data-id="element-453">
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-454">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-455">
                      Total Installments
                    </dt>
                    <dd className="mt-1 text-base font-bold text-gray-900" data-id="element-456">
                      12
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-457">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-458">
                      Paid
                    </dt>
                    <dd className="mt-1 text-base font-bold text-emerald-700" data-id="element-459">
                      {paidCount}
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-460">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-461">
                      Remaining
                    </dt>
                    <dd className="mt-1 text-base font-bold text-gray-900" data-id="element-462">
                      {remainingCount}
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-463">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-464">
                      Total Paid
                    </dt>
                    <dd className="mt-1 text-base font-bold text-gray-900" data-id="element-465">
                      PKR 194,868
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-466">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-467">
                      Outstanding
                    </dt>
                    <dd className="mt-1 text-base font-bold text-blue-600" data-id="element-468">
                      PKR 375,832
                    </dd>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-469">
                    <dt className="text-xs font-medium text-gray-500 uppercase" data-id="element-470">
                      Penalty Accrued
                    </dt>
                    <dd className="mt-1 text-base font-bold text-red-600" data-id="element-471">
                      PKR 500
                    </dd>
                  </div>
                </div>

                {/* Installment Table */}
                <div className="overflow-x-auto ring-1 ring-gray-200 rounded-lg" data-id="element-472">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-473">
                    <thead className="bg-gray-50" data-id="element-474">
                      <tr data-id="element-475">
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-476">
                          No
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-477">
                          Due Date
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-478">
                          Principal
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-479">
                          Interest
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-480">
                          Penalty
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-481">
                          Total
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-482">
                          Status
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-483">
                          Paid Date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-484">
                      {installments.map(row => <tr key={row.no} className={row.status === 'Overdue' ? 'bg-red-50' : ''} data-id="element-485">
                          <td className="px-4 py-2 text-sm text-gray-900" data-id="element-486">
                            {row.no}
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-500" data-id="element-487">
                            {row.due}
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-900" data-id="element-488">
                            {row.principal}
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-900" data-id="element-489">
                            {row.interest}
                          </td>
                          <td className="px-4 py-2 text-sm text-red-600" data-id="element-490">
                            {row.penalty}
                          </td>
                          <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-491">
                            {row.total}
                          </td>
                          <td className="px-4 py-2" data-id="element-492">
                            <StatusBadge status={row.status} data-id="element-493" />
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-500" data-id="element-494">
                            {row.paidDate}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </> : <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center" data-id="element-495">
                <p className="text-sm text-gray-500" data-id="element-496">
                  No repayment history available. Loan has not been disbursed.
                </p>
              </div>}
          </div>

          {/* SECTION 4: ACTIVITY LOG */}
          <div data-id="element-497">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-498">
              Activity Log
            </h4>
            <div className="overflow-x-auto ring-1 ring-gray-200 rounded-lg" data-id="element-499">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-500">
                <thead className="bg-gray-50" data-id="element-501">
                  <tr data-id="element-502">
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-503">
                      Activity Type
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-504">
                      Description
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-505">
                      Date
                    </th>
                    <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-506">
                      Time
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-507">
                  {activityLog.map((entry, idx) => <tr key={idx} data-id="element-508">
                      <td className="px-4 py-2 text-sm font-medium text-gray-900" data-id="element-509">
                        {entry.type}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-500" data-id="element-510">
                        {entry.description}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-500" data-id="element-511">
                        {entry.date}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-500" data-id="element-512">
                        {entry.time}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 flex flex-row-reverse gap-3 rounded-b-lg border-t border-gray-200" data-id="element-513">
          <button type="button" className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:w-auto" onClick={onClose} data-id="element-514">
            Close
          </button>
        </div>
      </div>
    </div>;
}